import { useState, useEffect } from 'react';
import AppShell from './components/AppShell';
import Home from './pages/Home';
import ResumoCompetencia from './pages/ResumoCompetencia';
import Dashboard    from './pages/Dashboard';
import Lancamentos  from './pages/Lancamentos';
import Retencoes    from './pages/Retencoes';
import Dividendos   from './pages/Dividendos';
import IrpfmAnual   from './pages/IrpfmAnual';
import Pendencias   from './pages/Pendencias';
import Alertas      from './pages/Alertas';
import Relatorios   from './pages/Relatorios';
import PlanoContas  from './pages/PlanoContas';
import Certificados from './pages/Certificados';
import Clientes     from './pages/Clientes';
import Mapeamento   from './pages/Mapeamento';
import ApuracaoDAS  from './pages/ApuracaoDAS';
import ApuracaoPisCofins from './pages/ApuracaoPisCofins';
import ApuracaoIrpjCsll  from './pages/ApuracaoIrpjCsll';
import SaudeCrossSystem  from './pages/SaudeCrossSystem';
import Integracoes       from './pages/Integracoes';
import ImportDominio     from './pages/ImportDominio';
import Imobilizado       from './pages/Imobilizado';
import Fechamento        from './pages/Fechamento';
import Configuracoes     from './pages/Configuracoes';
import NotasFiscais  from './pages/NotasFiscais';
import DistribuicaoLucros from './pages/DistribuicaoLucros';
import EmConstrucao from './pages/EmConstrucao';
import BemVindo from './pages/BemVindo';
import { listarPendenciasReinf, listarTxSemLcto } from './api';
import { bootstrapAuth } from './lib/sso';

// Autentica ANTES de montar o app: captura ?sso_token= vindo do Gesthub ou
// redireciona para o SSO. Sem isso o app rodava sem token e toda chamada
// morria em 403 (o modulo de SSO existia, mas nunca era chamado).
const AUTENTICADO = bootstrapAuth();

// Páginas implementadas (operacionais).
const PAGES = {
  home:         Home,
  'resumo-competencia': ResumoCompetencia,
  dashboard:    Dashboard,
  lancamentos:  Lancamentos,
  retencoes:    Retencoes,
  dividendos:   Dividendos,
  irpfm:        IrpfmAnual,
  pendencias:   Pendencias,
  alertas:      Alertas,
  relatorios:   Relatorios,
  plano:        PlanoContas,
  certificados: Certificados,
  clientes:     Clientes,
  mapeamento:   Mapeamento,
  'nf-escrituracao': NotasFiscais,
  'distribuicao-lucros': DistribuicaoLucros,
  'apuracao-das': ApuracaoDAS,
  'apuracao-pis-cofins': ApuracaoPisCofins,
  'apuracao-irpj-csll':  ApuracaoIrpjCsll,
  'saude-cross-system':  SaudeCrossSystem,
  'integracoes':         Integracoes,
  'import-dominio':      ImportDominio,
  'imobilizado':         Imobilizado,
  'fechamento':          Fechamento,
  'configuracoes':       Configuracoes,
};

// Páginas fiscais planejadas (placeholders) — informam o que vai ter quando
// implementarmos. Mantém o sistema mostrando o roadmap completo no menu.
const WIP_PAGES = {
  'efd-contribuicoes': {
    titulo: 'EFD-Contribuições',
    sub:    'SPED PIS/COFINS — mensal',
    descricao: 'Escrituração Fiscal Digital das contribuições PIS/COFINS. Bloco A (NF de serviços), F (operações sem documento), M (apuração consolidada), 1 (controle). Consome diretamente as apurações de PIS/COFINS já feitas no sistema.',
    proximoPasso: 'Gerador do arquivo .txt no layout RFB v6+ a partir das apurações mensais já existentes em apuracao_pis_cofins_mensal.',
  },
  'dctfweb': {
    titulo: 'DCTFWeb',
    sub:    'Declaração de Débitos e Créditos Tributários Federais — Web',
    descricao: 'DCTFWeb mensal — confessa contribuições previdenciárias (CPP do INSS, GILRAT, retenções 11%/3,5%) e outros tributos federais. Substituiu a GFIP a partir de out/2018 e a DCTF antiga em 2024. Integra com eSocial + EFD-Reinf automaticamente.',
    proximoPasso: 'Integração com eCAC via certificado ICP-Brasil (já temos vault). Push das DCTFWebs pendentes + retificação. Reuso dos eventos R-4010/R-4020 da Reinf já enviados.',
  },
  'mit': {
    titulo: 'MIT (Módulo de Inclusão de Tributos)',
    sub:    'Subsistema da DCTFWeb pra tributos não vindos do eSocial/Reinf',
    descricao: 'MIT é o subsistema da DCTFWeb usado pra incluir tributos que NÃO chegam automaticamente via eSocial nem EFD-Reinf — IRPJ, CSLL, PIS, COFINS, IRRF de fontes não-Reinf, etc. Vinculado à DCTFWeb da mesma competência.',
    proximoPasso: 'Após DCTFWeb estar operacional. Recebe valores das nossas apurações PIS/COFINS + IRPJ/CSLL e envia ao MIT via API RFB.',
  },
  'ecf': {
    titulo: 'ECF (Escrituração Contábil Fiscal)',
    sub:    'Anual — Lucro Presumido e Lucro Real',
    descricao: 'ECF substituiu a DIPJ a partir de 2014. Anual (até último dia útil de julho do ano seguinte). Contém LALUR (Livro Apuração Lucro Real), LACS (CSLL), apuração trimestral consolidada, balanço, DRE, demonstrações.',
    proximoPasso: 'Gerador do arquivo .txt no layout RFB ECF a partir dos lançamentos contábeis aprovados + apurações IRPJ/CSLL trimestrais já existentes.',
  },
  'defis': {
    titulo: 'DEFIS (Declaração de Informações Socioeconômicas e Fiscais)',
    sub:    'Anual — Simples Nacional',
    descricao: 'DEFIS é a obrigação anual do Simples Nacional (entregue até 31/03 do ano seguinte). Declara receita por estabelecimento, ganhos de sócios, mudanças de regime, dados socioeconômicos.',
    proximoPasso: 'Após DAS mensal estar com histórico de 12 meses. Consume dados de apuracao_das_mensal + Fator R do Notas + dados societários do Gesthub.',
  },
};

// Telas que nao precisam de empresa: sao as que se usa para arrumar o
// cadastro antes de escolher uma.
const PAGINAS_SEM_CLIENTE = new Set([
  'clientes', 'certificados', 'configuracoes', 'saude-cross-system', 'integracoes',
]);

export default function App() {
  if (!AUTENTICADO) return null; // redirect pro SSO em andamento

  const [page, setPage] = useState(
    () => window.location.hash.replace('#/', '') || 'home'
  );
  const [clienteId, setClienteId] = useState(null);
  const [badges, setBadges] = useState({});

  // Sincroniza com hash da URL pra permitir refresh/share
  useEffect(() => {
    window.location.hash = `/${page}`;
    const handler = () => setPage(window.location.hash.replace('#/', '') || 'home');
    window.addEventListener('hashchange', handler);
    return () => window.removeEventListener('hashchange', handler);
  }, [page]);

  // Carrega contadores de pendências pra mostrar badges no menu
  useEffect(() => {
    if (!clienteId) return;
    Promise.allSettled([
      listarPendenciasReinf(clienteId),
      listarTxSemLcto(clienteId, false),
    ]).then(([r1, r2]) => {
      const pReinf = r1.status === 'fulfilled' ? (r1.value.items?.length || 0) : 0;
      const pFin   = r2.status === 'fulfilled' ? (r2.value.items?.length || 0) : 0;
      setBadges({ pendencias: pReinf + pFin });
    });
  }, [clienteId, page]);  // recarrega ao trocar de tela

  const PageComp = PAGES[page];
  const wip = WIP_PAGES[page];

  return (
    <AppShell
      page={page}
      onNavigate={setPage}
      clienteId={clienteId}
      onSetClienteId={setClienteId}
      badges={badges}
    >
      {!clienteId && !PAGINAS_SEM_CLIENTE.has(page)
        ? <BemVindo />
        : PageComp
          ? <PageComp clienteId={clienteId} onNavigate={setPage} />
          : wip
            ? <EmConstrucao {...wip} />
            : <Dashboard clienteId={clienteId} />}
    </AppShell>
  );
}
